export default __webpack_public_path__ + "static/media/profesionales.c8bacbed.png";